import React from "react";

function AppButton({ text, styles, onClick }) {
  return (
    <button
      className="
      bg-mix-400
      font-semibold
      rounded-3xl
      px-6
      py-3
      text-white
      shadow-md
      uppercase
      hover:shadow-lg
      hover:bg-transparent
      hover:text-mix-400
      hover:text-semibold
      border-2
      border-mix-400
    "
      onClick={onClick}
    >
      {text}
    </button>
  );
}

export default AppButton;
